import { FC } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Brand } from "../../../../types"
import BrandAutocomplete from "../../brand-autocomplete"
import { useFindWorklowsQuery } from "../../../../redux/queries"
import LeadworkflowTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigLeadWorkflow: FC<Props> = ({ brands }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedBrandId = searchParams.get("brand_id") ?? ""

  const setSelectedBrandId = (id: string) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (id) next.set("brand_id", id)
      else next.delete("brand_id")
      return next
    })
  }

  const { data: workflows, isFetching } = useFindWorklowsQuery(
    selectedBrandId ?? "",
    {
      skip: !selectedBrandId
    }
  )

  return (
    <div>
      <BrandAutocomplete
        brands={brands}
        selected={selectedBrandId}
        onChange={setSelectedBrandId}
      />

      <div className="pt-6">
        {selectedBrandId ? (
          <LeadworkflowTable
            data={workflows ?? []}
            isFetching={isFetching}
            onSelect={id => navigate(`/config-admin/lead-workflow/${id}`)}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ConfigLeadWorkflow
